module.exports = __webpack_public_path__ + "img/p3.67653d65.png";